import { render, staticRenderFns } from "./QuestionHistoryModal.vue?vue&type=template&id=34394f0a&scoped=true"
import script from "./QuestionHistoryModal.vue?vue&type=script&lang=js"
export * from "./QuestionHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34394f0a",
  null
  
)

export default component.exports